import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import { useEffect, useState } from 'react'
import Axios from 'axios'
import swal from 'sweetalert'
import { Button, Modal } from 'react-bootstrap'
import { Cart } from '../components/Cart'
import K from '../services/k'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faClock,
  faUtensils,
  faInfoCircle,
  faTags,
} from '@fortawesome/free-solid-svg-icons'

// material ui imports
import * as React from 'react'

const MealComponent = ({ res, weekdayName, onClickMeal }) => {
  const [statesizes, setstatesizes] = useState([])
  const fetchsizes = async (mealid) => {
    var resp
    try {
      resp = await Axios.get(`${K.baseUrl}users/sizes/${mealid}`)
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.indexOf('log in') > -1
      ) {
        return
      }
    }
    if (resp && resp.message && resp.message.indexOf('log in') > -1) {
      return
    }
    if (resp.data.resultcode === 1) {
      setstatesizes(resp.data.sizes)
    } else {
      setstatesizes([])
    }
  }
  return (
    <div
      className="category-item"
      onClick={() => {
        res.status === 'available' &&
        (res.enable_weekday === '0' ||
          (res.enable_weekday === '1' &&
            res.weekdays !== null &&
            res.weekdays.includes(weekdayName)))
          ? onClickMeal(res)
          : alert('This Food Unavailable Today!')
      }}
    >
      <div
        className="left"
        style={{
          background: `ghostwhite url(${K.imageBaseUlr}images_fd/${res.image})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          width: '100%',
          height: '200px',
          borderTop: '1px solid #BDBCBC',
          borderBottom: '1px solid #BDBCBC',
          borderTopLeftRadius: '8px',
          borderBottomLeftRadius: '8px',
        }}
      >
        {res.status === 'unavailable' ? (
          <span className="badge badge-pill badge-danger">unavailable</span>
        ) : res.enable_weekday === '1' &&
          res.weekdays !== null &&
          !res.weekdays.includes(weekdayName) ? (
          <span className="badge badge-pill badge-danger">unavailable</span>
        ) : (
          <span className="badge badge-pill badge-success">available</span>
        )}
      </div>

      <div className="right">
        <h4>
          <i className="text-success mr-2">
            <FontAwesomeIcon icon={faUtensils} />
          </i>
          {res.meal}
        </h4>
        <p style={{ marginBottom: '0' }}>
          <i className="text-success mr-1">
            <FontAwesomeIcon icon={faInfoCircle} />
          </i>{' '}
          <br></br>
          {res.description}
        </p>
        <p>
          <i className="text-success mr-3">
            <FontAwesomeIcon icon={faTags} />
          </i>
          {res.category}
        </p>

        <div>
          {statesizes.map((res1, index) => (
            <div key={index} className="ml-1" style={{ marginBottom: '0' }}>
              <div
                style={{
                  display: 'inline-block',
                  width: '45px',
                }}
              >
                {statesizes.length > 1 ? res1.size : ''}
              </div>
              <b className="ml-2" style={{ fontSize: '15px' }}>
                JMD ${res1.price}
              </b>
            </div>
          ))}
        </div>

        <i className="text-success">
          <FontAwesomeIcon icon={faClock} />
        </i>
        <span className="ml-2">{res.wtime} min</span>
      </div>
      <div></div>
    </div>
  )
}

function SingleResturant(props) {
  const [theme, setTheme] = React.useState('')
  useEffect(() => {
    if (theme !== props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  // scroll to top of the page
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  // material ui card
  const [expanded, setExpanded] = React.useState(false)

  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  let arrayOfWeekdays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ]
  //reload cart
  const token = localStorage.getItem(['__react_session__'])
  const [show, setShow] = useState(false)
  const jsontoken = JSON.parse(token)
  const [weekdayName, setWeekdayName] = useState('')

  //Cart details
  const [qty, setqty] = useState(1)
  const [sizename, setsizename] = useState('')
  const [sizeprice, setsizeprice] = useState(0)

  if (
    jsontoken !== null &&
    jsontoken.api_token &&
    jsontoken.api_token !== null &&
    jsontoken.api_token !== ''
  ) {
    var loggedin = true
  } else {
    var loggedin = false
  }
  const history = useHistory()

  let location = useLocation()

  let match = useRouteMatch()

  const [resinfo, setresinfo] = useState(null)
  const [resMeals, setResMeals] = useState(null)
  const [categories, setcategories] = useState([])
  let restaurantId = 0
  try {
    restaurantId = isNaN(parseInt(localStorage.getItem('restaurantId')))
      ? 0
      : parseInt(localStorage.getItem('restaurantId'))
  } catch (error) {
    console.log(error)
  }

  useEffect(() => {
    Axios.get(`${K.baseUrl}restaurant/${restaurantId}`)
      .then((res) => {
        if (res.data && res.data.data) {
          let data = res.data.data
          if (
            data.restaurant &&
            data.restaurant.length > 0 &&
            data.meals &&
            data.meals.length > 0
          ) {
            setResMeals(data.meals)
            setresinfo(data.restaurant[0])
          } else {
            location.href = '/not-found'
          }
        } else {
          location.href = '/not-found'
        }
      })
      .catch((err) => {
        location.href = '/not-found'
      })

    var dateObj = new Date()
    var weekdayNumber = dateObj.getDay()
    setWeekdayName(arrayOfWeekdays[weekdayNumber])
  }, [restaurantId])

  useEffect(() => {
    if (resinfo && resMeals) {
      fetchcategories(restaurantId)
    }
  }, [resinfo, resMeals])

  const fetchcategories = async (restaurantId) => {
    var resp
    try {
      resp = await Axios.get(`${K.baseUrl}users/menus?id=${restaurantId}`)
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.indexOf('log in') > -1
      ) {
        props.logOut()
        return
      }
    }
    if (resp && resp.message && resp.message.indexOf('log in') > -1) {
      props.logOut()
      return
    }
    if (resp.data.resultcode === 1) {
      var cat = resp.data.menus
      var exist_cat = []
      cat.map((cat_item, cat_index) => {
        var filtered_meals = resMeals.filter(function (meal) {
          return meal.menu_type_id === cat_item.id
        })
        if (filtered_meals && filtered_meals.length > 0) {
          exist_cat.push(cat_item)
        }
      })
      exist_cat.unshift({ id: -1, name: 'All', description: '' })
      setcategories(exist_cat)
    }
  }

  //alert if not logged in
  const [currentmealid, setcurrentmealid] = useState(0)
  const [currentmeal, setcurrentmeal] = useState({})
  const alertlogin = () => {
    if (!loggedin) {
      swal({
        title: 'Alert!',
        text: 'Please login!',
        icon: 'warning',
      })
      props.logOut()
    }
  }
  const [statesizes, setstatesizes] = useState([])
  const fetchsizes = async (mealid) => {
    var resp
    try {
      resp = await Axios.get(`${K.baseUrl}users/sizes/${mealid}`)
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.indexOf('log in') > -1
      ) {
        props.logOut()
        return
      }
    }
    if (resp && resp.message && resp.message.indexOf('log in') > -1) {
      props.logOut()
      return
    }
    if (resp.data.resultcode === 1) {
      setstatesizes(resp.data.sizes)
      setqty(1)
      setsizename(
        resp.data.sizes.length > 0 ? resp.data.sizes[0].size : 'Normal',
      )
      setsizeprice(resp.data.sizes.length > 0 ? resp.data.sizes[0].price : 0)
      settotals(resp.data.sizes.length > 0 ? resp.data.sizes[0].price : 0)
      setcurrentmealid(mealid)
    } else {
      setstatesizes([])
      setqty(1)
      setsizeprice(0)
      settotals(0)
      setcurrentmealid(mealid)
    }
  }
  const handleClose = () => setShow(false)
  //assign flavours to states
  const [stateflavours, setstateflavours] = useState([])

  const fetchflavours = async (mealid) => {
    var resp
    try {
      resp = await Axios.get(`${K.baseUrl}users/flavours/${mealid}`)
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.indexOf('log in') > -1
      ) {
        props.logOut()
        return
      }
    }
    if (resp && resp.message && resp.message.indexOf('log in') > -1) {
      props.logOut()
      return
    }
    if (resp.data.resultcode === 1) {
      var flavours = resp.data.flavours

      flavours.map((flavour, index) => {
        var flavour_items = flavour.flavour_items
        flavour_items.map((flavour_item, item_index) => {
          flavour_item.selected = 0
          if (flavour.multi_select === '0' && item_index === 0) {
            flavour_item.selected = 1
          }
        })
      })

      setstateflavours([...flavours])
      setcurrentmealid(mealid)
      setflavourname('No Option')
      setflavourid(0)
    }
  }

  useEffect(() => {
    totalcalculate()
  }, [stateflavours, qty, sizeprice])

  const totalcalculate = (meal_flavours = null) => {
    var size_price = sizeprice
    var option_price = 0

    var flavours = meal_flavours !== null ? meal_flavours : stateflavours
    flavours.map((flavour, index) => {
      var flavour_items = flavour.flavour_items
      flavour_items.map((flavour_item, item_index) => {
        if (flavour_item.selected === 1) {
          var add_price = parseInt(flavour_item.add_price)
          if (add_price > 0) {
            option_price = option_price + add_price
          }
        }
      })
    })
    settotals(qty * (parseInt(size_price) + option_price))
  }

  const quantitychange = (e) => {
    setqty(e.target.value)
  }
  const sizechange = (e) => {
    var index = e.nativeEvent.target.selectedIndex
    setsizename(e.nativeEvent.target[index].text)
    setsizeprice(e.target.value)
  }

  //total states
  const [totals, settotals] = useState(sizeprice)

  const addqty = () => {
    setqty(qty + 1)
  }
  const subqty = () => {
    if (qty > 1) {
      setqty(qty - 1)
    }
  }

  //change in value of size state
  //size name0
  const [flavourname, setflavourname] = useState('No Option')
  //size price
  const [flavourid, setflavourid] = useState(0)
  const flavourchange = (e) => {
    let flavourindex = e.target.value
    let flavourid, flavourname
    try {
      flavourid =
        flavourindex === 0 || flavourindex === ''
          ? 0
          : stateflavours[flavourindex - 1].id
      flavourname =
        flavourindex === 0 || flavourindex === ''
          ? 'No Option'
          : stateflavours[flavourindex - 1].flavour
    } catch (error) {
      flavourid = 0
      flavourname = 'No Option'
    }
    setflavourname(flavourname)
    setflavourid(flavourid)
  }

  const optionChange = (e) => {
    let option_id = e.target.getAttribute('data-option-id')
    let option_item_id = e.target.getAttribute('data-option-item-id')
    let checked = e.target.checked
    const flavours = stateflavours.map((flavour) => {
      if (option_id === flavour.id) {
        const flavour_items = flavour.flavour_items.map((flavour_item) => {
          if (flavour.multi_select === '0') {
            flavour_item.selected = 0
          }
          if (flavour_item.id === option_item_id) {
            flavour_item.selected = checked ? 1 : 0
          }
          return flavour_item
        })
        flavour['flavour_items'] = flavour_items
        flavour['flavouritems'] = flavour_items
        return flavour
      } else {
        return flavour
      }
    })
    setstateflavours(flavours)
  }

  //check cart response
  const [cartresponse, setcartresponse] = useState(0)
  const [cartmessage, setcartmessage] = useState('')
  const addtocart = async () => {
    ///fetchuser/{id}/{apiToken}
    //jsontoken.api_token
    //apiToken,quantity,price,total,meal_id,size,flavour,flavourid,restaurant_id,client_id
    setcartresponse(3)
    const data = {
      apiToken: jsontoken.api_token,
      quantity: qty,
      price: sizeprice,
      total: totals,
      meal_id: currentmealid,
      size: sizename,
      flavour: flavourname,
      flavourid: flavourid,
      options: stateflavours,
      restaurant_id: resinfo.id,
      client_id: jsontoken.user_id,
    }
    var resp
    try {
      resp = await Axios.post(`${K.baseUrl}addtocart`, data)
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.indexOf('log in') > -1
      ) {
        props.logOut()
        return
      }
    }
    if (resp && resp.message && resp.message.indexOf('log in') > -1) {
      props.logOut()
      return
    }
    if (
      resp.data.resultcode === 0 &&
      resp.data.message === 'Invalid access token please log in'
    ) {
      props.logOut()
      return
    } else if (resp.data.resultcode === 1) {
      setcartresponse(1)
      setcartmessage(resp.data.message)
      handleClose()
    } else {
      setcartresponse(2)
    }
    setcartmessage(resp.data.message)
    // fetchcart();
  }
  //fetch cart

  const renderSizeSelect = () => {
    if (statesizes.length > 1) {
      return (
        <select onChange={sizechange}>
          {statesizes.length > 0 ? (
            statesizes.map((statesize, index) => (
              <option key={index} value={statesize['price']}>
                {statesize.size}
              </option>
            ))
          ) : (
            <option value="0">No size</option>
          )}
        </select>
      )
    } else {
      return null
    }
  }

  const onClickMeal = async (res) => {
    // setcurrentmealid(res.id); fetchsizes(res.id); fetchflavours(res.id); alertlogin();

    alertlogin()
    setcartresponse(0)
    setqty(1)
    setcurrentmeal(res)
    setcurrentmealid(res.id)
    await fetchsizes(res.id)
    await fetchflavours(res.id)

    setShow(true)
  }
  //remove item from cart
  if (categories === undefined) {
    return <div></div>
  } else {
    return (
      <div
        className={theme && theme === 'DARK' ? 'dark_theme' : 'light_theme'}
        style={{ marginBottom: '-50px' }}
      >
        <div className="main-wrapper inner--page">
          {resinfo && resinfo.bannerimage && (
            <section
              className="hero-banner restaurant-page inner-banner center-bg"
              style={{
                backgroundImage: `url(${K.imageBaseUlr}img/${resinfo.bannerimage})`,
                backgroundSize: '1300px 400px ',
                backgroundRepeat: 'no-repeat',
                position: 'relative',
              }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="banner-content category-content">
                      <div className="col-lg-6 col-md-6 col-sm-6 text-left">
                        <h2 style={{ textShadow: 'rgb(34 34 34) 2px 2px' }}>
                          {resinfo.rname}
                        </h2>
                        <span className="d-none">
                          4.5 (137 ratings) • 600 ft • $
                        </span>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 text-right d-none">
                        <span>
                          {' '}
                          Delivery Fee <b>$0.99</b>
                        </span>
                        <span>
                          {' '}
                          | <b>18-28</b> Min
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          <section className="category-tabs srpage">
            <div className="container">
              <div className="row">
                <div className="col-lg-9 col-md-12 col-sm-12">
                  <h3>Menus</h3>
                  <ul id="tabs" className="nav nav-tabs sRpage" role="tablist">
                    {categories?.length > 0 ? (
                      categories.map((category, index) => (
                        <li className="nav-item" key={index}>
                          <a
                            id={'tab-' + category.id}
                            href={'#pane-' + category.id}
                            className={
                              category.id === -1
                                ? `nav-link active`
                                : `nav-link`
                            }
                            data-toggle="tab"
                            role="tab"
                          >
                            {category.name}
                          </a>
                        </li>
                      ))
                    ) : (
                      <div></div>
                    )}
                  </ul>
                  <div id="content" className="tab-content" role="tablist">
                    {categories.map((category, index) => (
                      <div
                        id={'pane-' + category.id}
                        className={
                          index === 0
                            ? 'tab-pane fade show active'
                            : 'tab-pane fade'
                        }
                        role="tabpanel"
                        aria-labelledby={'tab-' + category.name}
                        key={index}
                      >
                        <div className={'row m-0 p-0'}>
                          {resMeals.map((res, index) =>
                            category.name === 'All' ||
                            res.menu_type_id === category.id ? (
                              <div className="col-md-6 col-sm-12" key={index}>
                                <MealComponent
                                  weekdayName={weekdayName}
                                  onClickMeal={onClickMeal}
                                  res={res}
                                />
                              </div>
                            ) : (
                              ''
                            ),
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <Cart
                  logOut={props.logOut}
                  resinfo={resinfo}
                  onChange={cartresponse}
                />
              </div>
            </div>
          </section>
        </div>
        <Modal
          show={show && currentmeal !== null}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          className={
            theme && theme === 'DARK'
              ? 'modal_confirm_order_dark'
              : 'modal_confirm_order_light'
          }
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <h4>
              <i className="text-success mr-2">
                <FontAwesomeIcon icon={faUtensils} />
              </i>
              {currentmeal.meal}
            </h4>
            <p style={{ marginBottom: '0' }}>
              <i className="text-success mr-1">
                <FontAwesomeIcon icon={faInfoCircle} />
              </i>{' '}
              <br></br>
              {currentmeal.description}
            </p>
            <p>
              <i className="text-success mr-3">
                <FontAwesomeIcon icon={faTags} />
              </i>
              {currentmeal.category}
            </p>
            <div className="size">
              {statesizes && statesizes.length > 1 && <h4>Select the size</h4>}
              {renderSizeSelect()}
              {currentmeal.type !== 'meal_prep' && (
                <div className="quantity">
                  <h4>Choose Quantity</h4>
                  <div className="quantity-btns">
                    <button id="minus" onClick={subqty}>
                      -
                    </button>
                    <span id="number">{qty}</span>
                    <button id="plus" onClick={addqty}>
                      +
                    </button>
                  </div>
                </div>
              )}
            </div>
            {stateflavours && stateflavours.length > 0 && (
              <div className="flavour">
                <h4>Select the option</h4>
                {stateflavours.map((stateflavour, index) => (
                  <div
                    data-option-id={stateflavour.id}
                    className="div_option_panel"
                    key={index}
                  >
                    <div className="mb-2">
                      <b>{stateflavour.flavour}</b>
                      <span className="ml-3">
                        (
                        {stateflavour.multi_select === '1'
                          ? 'Optional'
                          : 'Required-Choose 1'}
                        )
                      </span>
                    </div>
                    <div className="row m-0">
                      {stateflavour.flavour_items.map(
                        (flavour_item, item_index) => (
                          <div
                            className="col-sm-4 m-0 pl-2 pr-0"
                            key={'flavour-item' + item_index}
                          >
                            {stateflavour.multi_select === '1' ? (
                              <input
                                type="checkbox"
                                id={'option_item_' + flavour_item.id}
                                onChange={optionChange}
                                data-option-id={stateflavour.id}
                                data-option-item-id={flavour_item.id}
                              />
                            ) : (
                              <input
                                type="radio"
                                id={'option_item_' + flavour_item.id}
                                name={'option_' + stateflavour.id}
                                onChange={optionChange}
                                data-option-id={stateflavour.id}
                                data-option-item-id={flavour_item.id}
                                value={flavour_item.id}
                                checked={
                                  flavour_item.selected === 1 ? 'checked' : ''
                                }
                              />
                            )}
                            <label
                              htmlFor={'option_item_' + flavour_item.id}
                              className="mb-0"
                            >
                              <span>{flavour_item.name}</span>
                              {flavour_item.add_price !== '0' ? (
                                <span className="ml-2">
                                  {'+$' + flavour_item.add_price}
                                </span>
                              ) : (
                                ''
                              )}
                            </label>
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="total">
              <span>Totals: JMD ${totals}</span>
            </div>
            {cartresponse === 3 ? (
              <span>
                <p className="text-spinner-font">
                  <i className="fa fa-spinner fa-spin spinner-font"></i>
                  &nbsp;Please Wait...
                </p>
              </span>
            ) : cartresponse === 1 ? (
              <div className="alert alert-success">Added to Cart</div>
            ) : cartresponse === 2 ? (
              <div className="alert alert-danger">{cartmessage}</div>
            ) : (
              ''
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Back
            </Button>
            {totals === 0 || resinfo.opened === 0 ? (
              <span className="text-danger">
                {' '}
                The Restaurant Not Opened Yet!{' '}
              </span>
            ) : resinfo.open_status === 'close' ? (
              <span className="text-danger"> Unavailable for orders! </span>
            ) : (
              <Button variant="primary" onClick={addtocart}>
                Add to Cart
              </Button>
            )}
          </Modal.Footer>
        </Modal>
        <div className="modal-body"></div>
      </div>
    )
  }
}

export default SingleResturant
